module.exports = __webpack_public_path__ + "static/media/discord-en.c1fab372.webp";